import axios from 'axios';

import {
    FETCH_TRACKING_SUCCESS,
    EDIT_TRACKING_SUCCESS,
} from './type';

import { TRACKING_NOTE_URL } from './url';

export function editTrackingNote(orderId, data) {
    return (dispatch) => {
        axios({
            method: 'post',
            data: {
                notes: data,
            },
            url: `${TRACKING_NOTE_URL}${orderId}`,
            headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        }).then((response) => {
            // alert(JSON.stringify(response));
            dispatch(editTrackingNoteSuccess(response));
        }, (err) => {
            if (err.status === 500 || err.status === 404 || err.status === 400) {
                alert(JSON.stringify(err.data));
            }
        });
    };
}

function editTrackingNoteSuccess(response) {
    return {
        type: EDIT_TRACKING_SUCCESS,
        payload: response,
    }
}

export function fetchTrackingNote(orderId) {
    return dispatch => {
        const id = orderId;
        axios.get(`${TRACKING_NOTE_URL}${id}`,
            {
                headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
            })
            .then((res) => {
                dispatch(fetchTrackingNoteSuccess(res.data.records));
            })
            .catch((err) => {
                console.log(err);
                // alert(JSON.stringify(err.data));
            })
    }
}

function fetchTrackingNoteSuccess(data) {
    return {
        type: FETCH_TRACKING_SUCCESS,
        payload: data,
    }
}



// WEBPACK FOOTER //
// ./master/jsx/actions/tracking_actions.js